import React from 'react';
import { Redirect } from 'react-router-dom';
import store from 'store';

import * as Path from '../../constants/Path';
import * as SignUpFlow from '../../constants/SignUpFlow';
import StepOneForm from '../../components/forms/StepOneForm';
import SignupProgress from '../../components/signup/SignupProgress';
import * as Onboarding from '../../analytics/Onboarding';
import StepAbandonmentTracker from '../../analytics/StepAbandonmentTracker';


class StepOne extends React.Component {
  completedRef = { current: false };

  componentDidMount() {
    window.amplitude.getInstance().logEvent('Visited Step 1');
    Onboarding.logVisitedStep(1);
  }

  goToNextStep = () => {
    this.completedRef.current = true;
    store.set('signupState', 'step2');
    this.props.history.push('/start/step2');
  }

  render() {
    const { isAuthed } = this.props;

    return (
      <div>
        {
          isAuthed ?
          <Redirect to={{
            pathname: Path.DASHBOARD
          }} /> :
          <div className="container">
            <StepAbandonmentTracker step={1} completedRef={this.completedRef} />
            <SignupProgress currentStep={1} totalSteps={SignUpFlow.TOTAL_STEPS} />
            <h2>Your address</h2>

            <StepOneForm goToNextStep={this.goToNextStep} />
          </div>
        }
      </div>
    );
  }
}

export default StepOne;
